import { useEffect } from "react";

const AdAccessibilityFix = () => {
  useEffect(() => {
    const updateAdElements = () => {
      const adImages = document.querySelectorAll('img[src*="sascdn.com"]');
      adImages.forEach((img) => {
        img.setAttribute("alt", "");
        img.setAttribute("aria-hidden", "true");
        img.setAttribute("role", "presentation");
      });

      const adButtons = document.querySelectorAll('[id^="sas_"] button');
      adButtons.forEach((btn) => {
        if (!btn.getAttribute("aria-label")) {
          btn.setAttribute("aria-label", "Chiudi pubblicità");
        }
      });
    };

    const observer = new MutationObserver(() => updateAdElements());
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Esecuzione iniziale
    updateAdElements();

    return () => observer.disconnect();
  }, []);

  return null;
};

export default AdAccessibilityFix;
